const SANCTUM_TOKEN_KEY = "reva_sanctum_token";

export const getSanctumToken = () => {
  try {
    return sessionStorage.getItem(SANCTUM_TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

export const setSanctumToken = (token) => {
  try {
    if (token) {
      sessionStorage.setItem(SANCTUM_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SANCTUM_TOKEN_KEY);
    }
  } catch (error) {
    // Ignore storage failures (private mode).
  }
};

export const clearSanctumToken = () => setSanctumToken(null);

export const attachSanctumToken = (client) => {
  client.interceptors.request.use((config) => {
    const token = getSanctumToken();
    if (token && !config.headers.Authorization && !config.headers.authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  return client;
};
